/* eslint-disable @typescript-eslint/no-explicit-any */
import { projectSharedCss } from '@app/projects/list/style.css';
import { translate, TranslateModifiers } from '@core/translate';
import { Component, css, html, LitElement, property, TemplateResult } from '@rxdi/lit-html';
import { Observable, of } from 'rxjs';

import { MaterialBoxCSS } from '../styles/material-box';
const style = css`
  ${projectSharedCss}
  ${MaterialBoxCSS}

p {
    margin-top: 0px;
    margin-bottom: 5px;
  }
  p.size-13 {
    font-size: 13px;
  }

  .profile-information {
    font-size: 13px;
    color: #0e0e0e;
    font-weight: bold;
    margin-left: 10px;
  }

  .profile-information-container {
    width: auto;
    color: #0e0e0e;
    font-size: 14px;
  }
`;
/**
 * @customElement info-card-component
 */
@Component({
  selector: 'info-card-component',
  style,
  modifiers: [...TranslateModifiers],
  template(this: InfoCardComponent) {
    return html`
      <card-component>
        <div style="padding: 20px;margin-bottom: 20px;">
          <span style="color: #32435d; font-weight: bold" translate>${this.text ? this.text : this.title}</span>
          <spacer-component></spacer-component>
          <rx-monad>
            <rx-state .value=${this.infoItems}></rx-state>
            <rx-style .value=${style}></rx-style>
            <rx-render
              .state=${(infoItems) => html`
                <bootstrap-component></bootstrap-component>
                ${infoItems.map(
                  (i) => html`
                    <div class="size-13" style="margin-top: 10px;">
                      <div class="flex">
                        <div class="profile-information-container">${i.key}</div>
                        <div class="profile-information">${i.value}</div>
                        <span class="spacer"></span>
                      </div>
                    </div>
                  `
                )}
              `}
            ></rx-render>
          </rx-monad>
          <slot></slot>
        </div>
      </card-component>
    `;
  },
})
export class InfoCardComponent extends LitElement {
  @property({ attribute: false }) infoItems:
    | Observable<{ key: TemplateResult | string; value: TemplateResult | string }[]>
    | unknown[] = of([]);
  @property() title: string;
  @property() text: string;
}
